import { observer } from "mobx-react";
import { Button } from "primereact/button";
import React from "react";
import { useLocStore } from "../../../../wsLocalization";
import { LocContext } from "../../../../wsLocalization/LocContext";
import { CVEditDocument } from "./CVEditDocument";

export interface CVEditDeleteDocumentButtonProps {
  cveDocument: CVEditDocument;
  onDeleteDocumentClick: (cveDocument: CVEditDocument) => any;
}

export const CVEditDeleteDocumentButton = observer(
  ({ cveDocument, onDeleteDocumentClick }: CVEditDeleteDocumentButtonProps) => {
    const L = useLocStore(LocContext.CV);

    return (
      <Button
        icon="pi pi-trash"
        disabled={cveDocument.id < 0}
        title={L.id("6832fa0e6488").loc("Slett dokument")}
        className="p-button-rounded p-button-text p-button-icon-only cve-document-list-trashcan"
        onClick={(evt) => {
          evt.preventDefault();
          onDeleteDocumentClick(cveDocument);
        }}
      />
    );
  }
);
